<template>
<div style="background-color:#fff;padding:10px;">
    <div class="query-form">
        <a-row type="flex" style="width: 100%;">
        <a-col :sm="24" :md="24" :lg="21" :xl="21">
            
            <div class="search-keyword">
            <a-input placeholder="输入关键字搜索" v-model="blurry" style="margin: 0 20px;" @pressEnter="blurrySearch"></a-input>
            <a-button @click="blurrySearch" type="primary">搜索</a-button>
            </div>
        </a-col>
        <a-col :sm="24" :md="24" :lg="3" :xl="3">
            <a-button type="primary" style="float:right;margin: 8px 20px 8px 0px;" @click="openAddClient()">添加标签</a-button>
        </a-col>
        </a-row>
    </div>
    <div class="table">
        <a-table
        :columns="columns"
        :dataSource="tableData"
        :pagination="pagination"
        @change="pagChange"
        @expandRowByClick="true"
        :rowKey="record => record.id"
        :loading="loading"
        >
            <template slot="name"  slot-scope="record">
            <p>{{record.name}}</p>
            <p>{{record.orgcode}}</p>
            </template>
            <template slot="operation"  slot-scope="record">
            <a-button v-if="!record.enable" type="link" @click="editClient({'name':record.name,'orgcode':record.orgcode,'id':record.id})" style="padding:0;">编辑</a-button>
            <a-button v-else type="link" style="padding:0;" disabled>编辑</a-button>
            <a-divider type="vertical" />
            <a-button type="link" style="padding:0;">删除</a-button>
            </template>
        </a-table>
    </div>
</div>
</template>

<script>
const align = 'center'
const columns = [
  {
    title: "标签名",
    scopedSlots: { customRender: 'name' },
    align
  },
  {
    title: "证书数量(份)",
    dataIndex: "certNum",
    align
  },
   {
    title: "报告数量(份)",
    dataIndex: "reportNum",
    align
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'operation' },
    align
  }
];
import { getLabel } from '@/api/user'
export default {
  data() {
    return {
      tableData:[],
      blurry:'',
      state: 1,
      loading: false,
      columns,
      pagination: {
        showSizeChanger:true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChange:(current, pageSize) => {
          this.pageSize = pageSize
        }
      },
    };
  },
  methods: {
    async clientManage(){
      this.$refs.tableList.loading =true;
      this.pagination =  this.$refs.tableList.pagination;
      this.params.page = this.pagination.current-1
      this.params.size=this.pagination.pageSize
      this.params.blurry=this.blurry
      try{
        let data = await clientManage(this.params)
        this.TableList = data.content
        this.$refs.tableList.pagination.total = data.totalElements
        this.$refs.tableList.pagination.current = data.page
        this.$refs.tableList.pagination.pageSize = data.size
        this.$refs.tableList.loading =false;
      } catch (error) {
        console.log(error)
        this.$refs.tableList.loading =false;
      }
    },

  }
};
</script>

<style lang="less" scoped>
.query-form {
  background-color: #fff;
  overflow: hidden;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  

  .search-keyword {
    max-width: 500px;
    width: 57%;
    min-width: 400px;
    float: left;
    margin: 8px 20px  8px 0;
    display: flex;
    align-items: center;
    .ant-input {margin-right: 10px;}
  }
}
.table {
  background-color: #fff;
  .ant-alert-info {
    padding: 3px 15px 3px 37px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;

    /deep/.ant-alert-icon {top: auto !important;}

    .info-slot {
      display: flex;
      align-items: center;

      .ant-btn {padding-right: 0px;}
    }
  }
  .btnTag{
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    border-radius: 4px;
    margin-right:5px;
  }
}
</style>
